import angular from "angular";
import moment from "moment-timezone";

import Assert from "tbAssert";

const mScopeSvc = new WeakMap();
const mCurrentTimeZoneSvc = new WeakMap();

const mStart = new WeakMap();
const mEnd = new WeakMap();
const mEventDateDisplayStyle = new WeakMap();

class CalendarEventDateTimeController {
    constructor($scope, CurrentTimeZone) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Controller Scope Dependency");
        Assert.StrictAssert(CurrentTimeZone != null, "Assertion Failure: Missing Current Time Zone Service Dependency");

        mScopeSvc.set(this, $scope);
        mCurrentTimeZoneSvc.set(this, CurrentTimeZone);

        mStart.set(this, null);
        mEnd.set(this, null);
        mEventDateDisplayStyle.set(this, "invalid");

        $scope.$watch(
            () => { return this.eventStart; },
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    let updatedStart = this._translateExternalParameter(this.eventStart);
                    mStart.set(this, updatedStart);
                    this._updateDateDisplayStyle();
                }
            }
        );

        $scope.$watch(
            () => { return this.eventEnd; },
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    let updatedEnd = this._translateExternalParameter(this.eventEnd);
                    mEnd.set(this, updatedEnd);
                    this._updateDateDisplayStyle();
                }
            }
        );
    }

    get start() {
        return mStart.get(this);
    }

    // set start(newVal) {
    //     mStart.set(this, newVal);
    // }

    get end() {
        return mEnd.get(this);
    }

    // set end(newVal) {
    //     mEnd.set(this, newVal);
    // }

    get eventDateDisplayStyle() {
        return mEventDateDisplayStyle.get(this);
    }

    _translateExternalParameter(extParam) {
        if (extParam == null) { return null; }

        let resultMoment = null;

        if (moment.isMoment(extParam)) {
            resultMoment = extParam.clone();
        }
        else if (angular.isDate(extParam)) {
            let extParamClone = new Date(extParam.getTime());
            resultMoment = moment(extParamClone);
        }
        else if (angular.isString(extParam)) {
            resultMoment = moment(extParam);
            if (!resultMoment.isValid()) {
                resultMoment = null;
            }
        }

        if (resultMoment != null) {
            resultMoment.tz(mCurrentTimeZoneSvc.get(this).get());
            return resultMoment;
        }

        return null;
    }

    _updateDateDisplayStyle() {

        if ((this.start == null) ||
            (this.end == null)) {

            mEventDateDisplayStyle.set(this, "invalid");
        }
        else {
            let updatedDisplayStyle =
                (mStart.get(this).isSame(mEnd.get(this), "day")) ?
                    "same" :
                    "different";

            mEventDateDisplayStyle.set(this, updatedDisplayStyle);
        }
    }

    $onInit() {
        let initStart = this._translateExternalParameter(this.eventStart);
        let initEnd = this._translateExternalParameter(this.eventEnd);

        mStart.set(this, initStart);
        mEnd.set(this, initEnd);

        this._updateDateDisplayStyle();
    }
}

CalendarEventDateTimeController.$inject = [ "$scope", "CurrentTimeZone" ];

export default CalendarEventDateTimeController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/CalendarEventDateTime/CalendarEventDateTimeController.js
// module id = U0jI
// module chunks = 1